export default __webpack_public_path__ + "static/ogr-small-logo-1ea22b8f4bcc26a9bd22470916961eb4.jpeg";